import { supabase } from '../lib/supabase';

export const fetchInventory = async () => {
  const { data, error } = await supabase
    .from('inventory_items').select('*').order('name', { ascending: true });
  if (error) throw error;
  return data || [];
};

export const saveInventoryItem = async (payload, editId) => {
  if (editId) {
    const { error } = await supabase.from('inventory_items').update(payload).eq('id', editId);
    if (error) throw error;
  } else {
    const { error } = await supabase.from('inventory_items').insert([payload]);
    if (error) throw error;
  }
};

export const deleteInventoryItem = async (id) => {
  const { error } = await supabase.from('inventory_items').delete().eq('id', id);
  if (error) throw error;
};
